export default {
  SET_IS_AUTHENTICATED: "SET_IS_AUTHENTICATED",
  SET_USER: "SET_USER",
};
